// extracted by mini-css-extract-plugin
module.exports = {"photo":"WSVirtualAssistant_photo__fhkKe","card":"WSVirtualAssistant_card__2Wy7B","msg":"WSVirtualAssistant_msg__IbpwP"};